// removed by extract-text-webpack-plugin
module.exports = {"sm":"only screen and (min-width: 48em)","md":"only screen and (min-width: 64em)","lg":"only screen and (min-width: 75em)","suggestedGoalContainer":"suggestedGoalContainer-1FI0A","setGoalButton":"setGoalButton-2cg1g","goalName":"goalName-3UNur","startDate":"startDate-21oPz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/goals/view/_suggestedGoal.css
// module id = 1206
// module chunks = 1